import React, { useMemo } from "react";
import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import {
  extractDate,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import CovidComponent from "./CovidComponent";

const Covid19 = () => {
  const { getText } = useLanguageTranslation();

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={getText("COVID-19", "कोविड-19")}
        titleLink="/covid-19"
        levelTwo={false}
        levelThree={false}
        isActive={getText("COVID-19", "कोविड-19")}
      />
      <div className="inner-container">
        <div className="container">
          <section className="ourCompany">
            <div className="container">
              <CovidComponent />
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Covid19;
